var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "v-tabs form-group" }, [
    _c(
      "div",
      {
        staticClass: "tab-nav",
        class: [`tab-nav--${_vm.type}`, { "tab-nav--disabled": _vm.disabled }],
      },
      [
        _c(
          "div",
          { ref: "tabNavActions", staticClass: "tab-nav-actions" },
          _vm._l(_vm.navCfgs, function (item) {
            return _c(
              "span",
              {
                key: item.value,
                ref: `refNavItems`,
                refInFor: true,
                staticClass: "tab-nav-item",
                class: [
                  `tab-nav--${_vm.size}`,
                  {
                    "tab-nav--active": item.value === _vm.currentValue,
                    "tab-nav-item--disabled": item.disabled === true,
                  },
                ],
                on: {
                  click: (event) =>
                    _vm.disabled || _vm.handleTabClick(item, event),
                },
              },
              [_vm._v(" " + _vm._s(item.label) + " ")]
            )
          }),
          0
        ),
        _vm.type === "link"
          ? _c("div", {
              ref: "tabActiveBorder",
              staticClass: "tab-active-border",
              class: {
                "tab-active-border--transition": _vm.activeBorderTransition,
              },
            })
          : _vm._e(),
      ]
    ),
    _c("div", { staticClass: "tab-pane-wrapper" }, [_vm._t("default")], 2),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }